import { createStyles, makeStyles } from '@material-ui/core';
import { PictureInPicture } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useDocumentPermissions, useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});
/**
 * Document widget component to toggleing redaction
 */
export const ToggleRedactionWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  const permissions = useDocumentPermissions();
  return /*#__PURE__*/React.createElement(ToggleBase, {
    disabled: !permissions.canHideRedaction,
    classes: classes,
    active: viewerState.showRedaction,
    title: localization.toggleRedaction,
    setValue: value => viewerState.updateState({
      showRedaction: value
    })
  }, /*#__PURE__*/React.createElement(PictureInPicture, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.showRedaction
    })
  }));
};
//# sourceMappingURL=toggle-redaction.js.map